import React from "react";

export default function LegalLayout({ title, updated, children }) {
    return (
        <div className="max-w-4xl mx-auto px-5 sm:px-8 py-16 lg:py-24" data-testid="legal-page">
            <div className="overline text-primary mb-4">Legal</div>
            <h1 className="font-display text-4xl sm:text-5xl font-bold tracking-tight mb-3">{title}</h1>
            <p className="text-sm text-muted-foreground mb-12">Last updated: {updated}</p>
            <div className="prose prose-slate max-w-none [&_h2]:font-display [&_h2]:text-2xl [&_h2]:font-bold [&_h2]:mt-10 [&_h2]:mb-4 [&_h3]:font-display [&_h3]:text-lg [&_h3]:font-semibold [&_h3]:mt-6 [&_h3]:mb-2 [&_p]:text-muted-foreground [&_p]:leading-relaxed [&_p]:mb-4 [&_ul]:list-disc [&_ul]:pl-6 [&_ul]:text-muted-foreground [&_ul]:mb-4 [&_li]:mb-1.5 [&_a]:text-primary [&_a]:underline">
                {children}
            </div>
        </div>
    );
}
